import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import cn from 'classnames'
import type {CustomerStoryDocument} from 'prismicio-types'
import {useMemo} from 'react'
import {Container} from 'src/common/Container'
import {CustomerStoryCard} from 'src/common/CustomerStoryCard'

const MAX_CARDS_AMOUNT = 3

/**
 * Props for `MoreCustomerStories`.
 */
export type MoreCustomerStoriesProps = SliceComponentProps<Content.MoreCustomerStoriesSlice> & {
  context: {
    moreCustomerStories: CustomerStoryDocument[]
    pageUid: string
  }
}

/**
 * Component for "MoreCustomerStories" Slices.
 */
const MoreCustomerStories = ({
  slice: {primary},
  context: {moreCustomerStories: stories, pageUid},
}: MoreCustomerStoriesProps): JSX.Element => {
  const storiesToDisplay = useMemo(() => stories.slice(0, MAX_CARDS_AMOUNT), [stories])

  if (stories?.length === 0) {
    return <></>
  }

  return (
    <Container className="!py-10 px-5 md:px-10 lg:px-5 xl:px-0" backgroundColor="Grey/100">
      <div className="grid-base gap-y-6 md:gap-y-12">
        <h2 className=" text-h3 md:text-h2 col-span-full text-moss-black">{primary.title}</h2>
        {storiesToDisplay.map((story, index) => (
          <div
            className={cn('col-span-full flex md:col-span-6 lg:col-span-4', {
              'md:max-lg:hidden': MAX_CARDS_AMOUNT === index + 1,
            })}
            key={story.id}
          >
            <CustomerStoryCard
              index={index}
              pageUid={pageUid}
              customerStory={story}
              readMoreLabel={primary.read_more_card_label}
            />
          </div>
        ))}
      </div>
    </Container>
  )
}

export default MoreCustomerStories
